module.exports = __webpack_public_path__ + "img/ichelps.e59bec56.jpg";